module.exports = __webpack_public_path__ + "img/alarm-clock-plus.dcdd002e.svg";